<app-slide id="jointSlide" title="Joint Applicant Details"
    supportingText="Please tell us about the Joint Applicant (A joint applicant is a person who will have equal rights & responsibilities for the property with you)"
    [slideNumber]="slideNumber" [finalSlide]="finalSlide" [active]="active.active === 'joint'"
    [slideCompleted]="formState.progress.jointApplicantComplete" *ngIf="jointApplication.enabled === true">
    <div class="alert alert-danger" *ngIf="showError">
        {{errorMessage}}
    </div>

    <div id="joint-error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it
            again.
        </p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title | titlecase}},
                    {{error.msg}}
                </a>
            </li>
        </ul>
    </div>

    <ng-container *ngIf="fields | async as fields">
        <!-- <div [ngStyle]="{ 'outline': form.valid ? '1px solid green' : '1px solid red' }"> -->
        <div>
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            <div class="section ng-empty" *ngIf="showSubmit">
                <div class="row">
                    <div class="col-sm-8">
                        <div class="form-group">
                            <button type="button" class="btn" style="position:relative;" (click)="onBack()">
                                <span>Back</span>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary" style="position: relative;"
                                (click)="onSubmit()" (disabled)="isDisabled">
                                <span>Save &amp; Continue Securely</span>
                                <app-spinner *ngIf="submitting" class="applicationSubmitSpinner"></app-spinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- <pre>
        {{model | json}}
    </pre> -->
</app-slide>